/** Case- and diacritics-insensitive text used for BOTH matching and highlighting: `retence` finds
 *  "Retence", `pamet` finds "Paměť". cmdk's built-in filter is not diacritics-aware, which is why the
 *  palette and the row pickers supply this normalization instead. */
export function normalizeText(text: string): string {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}

interface NormalizedText { normalized: string; /** Original UTF-16 span for each normalized UTF-16 unit. */ sources: { start: number; end: number }[] }

function normalizeWithMap(text: string): NormalizedText {
  let normalized = '';
  const sources: NormalizedText['sources'] = [];
  let i = 0;
  for (const ch of text) {
    const piece = normalizeText(ch);
    normalized += piece;
    for (let unit = 0; unit < piece.length; unit++) sources.push({ start: i, end: i + ch.length });
    i += ch.length;
  }
  return { normalized, sources };
}

/** Where `query` occurs inside `text`, compared diacritics-insensitively — returned as a range into the
 *  ORIGINAL string, so the palette can highlight the real (accented) substring. */
export function findNormalizedRange(text: string, query: string): [number, number] | null {
  const q = normalizeText(query);
  if (!q) return null;
  const { normalized, sources } = normalizeWithMap(text);
  const at = normalized.indexOf(q);
  if (at < 0) return null;
  return [sources[at]!.start, sources[at + q.length - 1]!.end];
}
